import type { IconData } from '@stacksjs/iconify-core'

export const messageAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m5.978 14.969l.002-.033zm.001-.167l.001.003v-.003zm.04 1.9c2.678-2.462 3.007-2.656 3.793-2.734C13.364 13.615 16 11.01 16 8.004c0-3.26-3.085-6.003-7-6.003S2 4.745 2 8.004c0 1.893 1.175 3.767 3.054 4.957c.783.495.958 1.117.941 1.778l-.009.15c.022.33.032.92.033 1.814zm3.99-.743q-.277.027-4.32 3.774a1 1 0 0 1-1.68-.742q.03-3.543-.024-4.04c-.018-.173.032-.28 0-.3C1.708 13.212 0 10.775 0 8.005C0 3.584 4.03 0 9 0s9 3.584 9 8.004c0 4.117-3.495 7.509-7.99 7.955z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default messageAlt
